import schema from './schema.json';

export default {
  init: () => {},
  schema
};
